import React, { useState, useRef, useEffect } from "react";

const CustomDropdown = ({ value, onChange }: { value: string; onChange: (value: string) => void }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const options = [
    { value: "active", label: "Active" },
    { value: "pending", label: "Pending" },
    { value: "all", label: "All" },
  ];

  const handleOptionClick = (optionValue: string) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative w-[105px]">
      <div
        className="bg-gray-500 text-white rounded-lg px-4 py-2 text-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        {options.find((option) => option.value === value)?.label}
      </div>
      {isOpen && (
        <ul className="absolute left-0 w-full bg-gray-500 text-white rounded-lg mt-1 shadow-lg z-10">
          {options.map((option) => (
            <li
              key={option.value}
              className="px-4 py-2 text-center hover:bg-gray-600 cursor-pointer"
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;